const { createSlice } = require('@reduxjs/toolkit');

const productSlice = createSlice({
    name: 'product',
    initialState: {
        products: [],
        categories: [],
        catalogError: "",
    },
    reducers: {
        setProducts(state, action) {
            state.products = action.payload;
            state.catalogError = "";
        },
        setCategories(state, action) {
            state.categories = action.payload;
        },
        setCatalogError(state, action) {
            state.catalogError = action.payload || "";
            state.products = [];
        }
    },
});

export const { setProducts, setCategories, setCatalogError } = productSlice.actions;
export default productSlice.reducer;
